/**
 * External dependencies
 */
import inherits from 'inherits';

export default class HostedPage {
    
    constructor(cscom) {
        if (!(this instanceof HostedPage)) {
            return new HostedPage(cscom);
        }
        this.cscom = cscom;
    }

    hostedPaymentMethods(data) {
        return this.cscom.req.get('/customer-site-api/chargebee/hosted-page/manage-payment-methods', null, data);
    }

    newSubscription(planId) {
        return this.cscom.req.post('/customer-site-api/chargebee/hosted-page/new-subscription', { planId });
    }

    newPlanSubscription(planId) {
        return this.cscom.req.post('/customer-site-api/chargebee/hosted-page/new-plan-subscription', { planId });
    }
}
